import { isDevMode } from './environment';

class Logger {
  enabled: boolean;
  constructor(enabled: boolean) {
    this.enabled = enabled;
  }

  run(fn: (...param: any) => any, ...param: any) {
    if (this.enabled) fn(...param);
  }
  info(...param: any) {
    this.run(console.info, ...param);
  }
  error(...param: any) {
    this.run(console.error, ...param);
  }
  warn(...param: any) {
    this.run(console.warn, ...param);
  }
  debug(...param: any) {
    this.run(console.debug, ...param);
  }
  trace(...param: any) {
    this.run(console.trace, ...param);
  }
  log(...param: any) {
    this.run(console.log, ...param);
  }
  table(...param: any) {
    this.run(console.table, ...param);
  }
}

const logger = new Logger(isDevMode());
const trace = logger.trace;

export { logger, trace };
